import { styled } from "@mui/styles";
import { Link as RouterLink } from "react-router-dom";
import Typography from "@mui/material/Typography";

// shared chart styles
export const GRID_STYLES = {
  stroke: "#D1D5DB",
  strokeWidth: 0.5,
  strokeDasharray: "6 6", // Longer dashes, shorter gaps
};

export const AXIS_STYLES = {
  stroke: "#9CA3AF", // Light gray color for axis lines
  strokeWidth: 0, // Thinner lines
  fontSize: 12, // Smaller font size
  fontWeight: 400, // Regular font weight
};

// ReferralFees.tsx styles
export const ReferralFeesWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  gap: "12px",
  alignItems: "center",
  alignSelf: "stretch",
  justifyContent: "space-between",

  [theme.breakpoints.down(720)]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}));

export const ReferralFeesDragWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  width: "80%",
  flexDirection: "column",
  alignItems: "flex-start",
  alignSelf: "stretch",
  cursor: "grab",

  [theme.breakpoints.down(720)]: {
    width: "100%",
    height: "154px",
  },
}));

export const RefferalFeesHeading = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",

  [theme.breakpoints.down(720)]: {
    alignSelf: "stretch",
  },
}));

export const ReferralFeedTitle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  fontSize: "14px",
  textDecoration: "none",
  color: "inherit",

  [theme.breakpoints.down(720)]: {
    justifyContent: "space-between",
    alignItems: "flex-start",
    alignSelf: "stretch",
  },
}));

export const ReferralFessText = styled("div")({
  fontWeight: 600,
  fontSize: "26px",
  cursor: "default",
});

// PopularCoins.tsx styles
export const PopularCoinsWrapper = styled("div")({
  height: "100%",
});

export const PopularCoinsList = styled("div")(({ theme }) => ({
  maxHeight: "250px",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "3px",
  },
}));

export const PopularCoinsListItem = styled("div")(({ theme }) => ({
  padding: "12px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
}));

export const PopularCoinsLinkCoin = styled(RouterLink)(({ theme }) => ({
  color: "inherit",
  cursor: "pointer",
  textDecoration: "none",
  "&:hover": {
    opacity: 0.7,
  },
}));

export const PopularCoinsIconTextGroup = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "12px",
  fontSize: "14px",
  cursor: "pointer",

  "&:hover": {
    opacity: 0.7,
  },
});

export const PopularCoinsText = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
}));
